// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"507":"privacyAgreement","673":"drink-menu","676":"drink-confirm","890":"userAgreement"}[chunkId] + "-" + __webpack_require__.h() + ".js";
};